import { useEffect, useState } from 'react';

const getDeviceType = () => {
  return window.matchMedia('(max-width: 1023px)').matches;
};

export const useDeviceType = () => {
  const [isMobile, setIsMobile] = useState(getDeviceType());

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(getDeviceType());
    };

    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('orientationchange', handleResize);
    };
  }, []);

  return isMobile;
};
